import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=21c206f7&scoped=true"
import script from "./Investment.vue?vue&type=script&setup=true&lang=ts"
export * from "./Investment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Investment.vue?vue&type=style&index=0&id=21c206f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c206f7",
  null
  
)

export default component.exports